// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dfnGZ","field":"styles_field__2KvMS","fieldCol":"styles_fieldCol__2-Kq4","diffCol":"styles_diffCol__2XTjn","diff":"styles_diff__1a1Cl"};